import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Components, Utils } from 'versafleet-core';
import { useGetOrderDetails } from 'queryActions/useOrderDetails';

function Footer() {
  const { domain } = useParams();
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="vf-tracking__contact-company">
        <Contact />
      </div>

      <Components.Button
        className="vf-tracking__new-track-button"
        color={null}
        onClick={() => {
          const pathname = domain ? `/${domain}` : '/';
          navigate(pathname);
        }}
        showShadow={false}
      >
        Track another order
      </Components.Button>
    </React.Fragment>
  );
}

function Contact() {
  const { orderDetails } = useGetOrderDetails();

  const { email, contact_number: contactNumber, name } = orderDetails?.account || {};

  const replaceMap = {
    companyName: name,
    companyEmail: (
      <Components.Link href={`mailto: ${email}`}>
        {email}
      </Components.Link>
    ),
    companyPhone: (
      <Components.Link href={`tel: ${contactNumber}`}>
        {contactNumber}
      </Components.Link>
    ),
  };

  let footerString = '';

  if (email && contactNumber) {
    footerString = 'Please contact #{companyName} at #{companyEmail} or call #{companyPhone} if you have any issues.';
  } else if (email) {
    footerString = 'Please contact #{companyName} at #{companyEmail} if you have any issues.';
  } else if (contactNumber) {
    footerString = 'Please contact #{companyName} at #{companyPhone} if you have any issues.';
  } else {
    footerString = 'Please contact #{companyName} if you have any issues.';
  }

  return Utils.TranslationHelper.replaceTag(footerString, replaceMap);
}

export default Footer;
